// src/pages/Home/Home.jsx
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import {
  Title,
  Subtitle,
  DashboardContainer,
  StatCard,
  StatNumber,
  StatLabel,
  CardsWrapper,
} from "./Home.styles";
import ExportUsuariosButton from "../../components/Buttons/ExportUsuariosButton";
import ExportGestantesButton from "../../components/Buttons/ExportGestantesButton";
import ExportRelatorioCompletoGestantesButton from "../../components/Buttons/ExportRelatorioCompletoGestantesButton";
import ToastManager from "../../components/Toast/ToastManager";
import { useToast } from "../../hooks/useToast";

const Home = () => {

  const { toasts, removeToast, showSuccess, showError } = useToast();
  const [qtdUsuarios, setQtdUsuarios] = useState(0);
  const [qtdGestantes, setQtdGestantes] = useState(0);
  const [qtdGestacoes, setQtdGestacoes] = useState(0);
  const [qtdConsultas, setQtdConsultas] = useState(0);
  const [qtdKitsEntregues, setQtdKitsEntregues] = useState(0);

  useEffect(() => {
    // Retorna o numero de usuarios cadastrados
    const fetchQtdUsuarios = async () => {
      try {
        const qtdUsuariosResponse = await api.get(`/relatorios/qtd-usuarios-cadastrados`);
        setQtdUsuarios(qtdUsuariosResponse.data);
      } catch (error) {
        console.error("Erro ao buscar a quantidade de usuários no sistema: ", error);
      }
    }

    // Retorna o numero de gestantes cadastradas 
    const fetchQtdGestantes = async () => {
      try {
        const qtdGestantesResponse = await api.get(`/relatorios/qtd-gestantes-cadastradas`);
        setQtdGestantes(qtdGestantesResponse.data);
      } catch (error) {
        console.error("Erro ao buscar a quantidade de gestantes no sistema: ", error);
      }
    }

    // Retorna o numero de gestacoes cadastradas 
    const fetchQtdGestacoes = async () => {
      try {
        const qtdGestacoesResponse = await api.get(`/relatorios/qtd-gestacoes-cadastradas`);
        setQtdGestacoes(qtdGestacoesResponse.data);
      } catch (error) {
        console.error("Erro ao buscar a quantidade de gestações cadastradas: ", error);
      }
    }

    // Retorna o numero de consultas realizadas 
    const fetchQtdConsultas = async () => {
      try {
        const qtdConsultasResponse = await api.get(`/relatorios/qtd-consultas-cadastradas`);
        setQtdConsultas(qtdConsultasResponse.data);
      } catch (error) {
        console.error("Erro ao buscar a quantidade de consultas cadastradas");
      }
    }

    // Retorna o numero de kits entregues 
    const fetchQtdKitsEntregues = async () => {
      try {
        const qtdKitsEntreguesResponse = await api.get(`/relatorios/qtd-kits-entregues`);
        setQtdKitsEntregues(qtdKitsEntreguesResponse.data);
      } catch (error) {
        console.error("Erro ao buscar a quantidade de kits entregues");
      }
    }

    fetchQtdUsuarios();
    fetchQtdGestantes();
    fetchQtdGestacoes();
    fetchQtdConsultas();
    fetchQtdKitsEntregues();
  }, []);

  return (
    <div>
      <DashboardContainer>
        <Title>Dashboard Geral</Title>
        <Subtitle>
          Estatísticas gerais dos kits e atendimentos a gestantes.
        </Subtitle>
        {/* align-items: flex-start impede que os botões estiquem à altura da linha */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "flex-start",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <ExportUsuariosButton />
          <ExportGestantesButton />
          <ExportRelatorioCompletoGestantesButton
            showSuccess={showSuccess}
            showError={showError}
          />
        </div>
        <CardsWrapper>
          <StatCard>
            <StatNumber>{qtdUsuarios}</StatNumber>
            <StatLabel>Usuários Cadastrados</StatLabel>
          </StatCard>
          <StatCard>
            <StatNumber>{qtdGestantes}</StatNumber>
            <StatLabel>Gestantes Cadastradas</StatLabel>
          </StatCard>
          <StatCard>
            <StatNumber>{qtdGestacoes}</StatNumber>
            <StatLabel>Gestações Cadastradas</StatLabel>
          </StatCard>
          <StatCard>
            <StatNumber>{qtdConsultas}</StatNumber>
            <StatLabel>Consultas Realizadas</StatLabel>
          </StatCard>
          <StatCard>
            <StatNumber>{qtdKitsEntregues}</StatNumber>
            <StatLabel>Kits Entregues</StatLabel>
          </StatCard>
        </CardsWrapper>
      </DashboardContainer>
      <ToastManager toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default Home;
